<template>
  <print-template :viewFooter="false">
    <h3 class="mt-3 mb-2">Delivery Note</h3>
    <table class="table table-bordered">
      <tr>
        <th>Description</th>
        <th>Part No.</th>
        <th>ULD ID Code</th>
        <th>Serial</th>
        <th>Status</th>
      </tr>
      <tr v-for="item in list.data" :key="item.id">
        <td>
          <span>{{ getMasterlistDescription(item.masterlist) }}</span>
        </td>
        <td>{{ item.masterlist.part }}</td>
        <td>{{ item.masterlist.uld_id_code }}</td>
        <td>{{ item.masterlist.tso_serial_no }}</td>
        <td>{{ item.status.name }}</td>
      </tr>
    </table>
  </print-template>
</template>

<script>
import ULD from "@/models/ULD";
import Masterlist from "@/models/Masterlist";
import PrintTemplate from "@/components/PrintTemplate.vue";
export default {
  name: "DeliveryReport",
  components: { PrintTemplate },
  data: () => ({
    isLoading: false,
    list: { data: [], paging: {} },
    pager: { limit: 15 },
    descriptions: Masterlist.descriptions()
  }),
  methods: {
    fetch(page) {
      this.isLoading = true;
      this.pager.page = 1;
      if (page) {
        this.pager.page = page;
      }
      let params = {
        ...this.pager,
        is_report: 1
      };
      ULD.list(params).then(list => {
        this.list = list;
        this.isLoading = false;
      });
    },
    getMasterlistDescription(masterlist) {
      let check = this.descriptions.find(
        o => o.value == masterlist.description
      );
      if (check) return check.text;
      else return "";
    }
  },
  mounted() {
    if ("limit" in this.$route.query)
      this.pager.limit = this.$route.query.limit;
    if ("page" in this.$route.query) this.pager.page = this.$route.query.page;
    this.fetch(1);
  }
};
</script>

<style></style>
